import { Component, Input, OnInit } from '@angular/core';
import { exibirToast } from 'src/app/modules/_functions/alerts';
import { Membro } from '../../../_models/membro';
import {
  Solicitacoes,
  SolicitacoesStatus,
} from '../../../_models/solicitacoes';

import { FidelidadeService } from '../../../_services/fidelidade.service';

@Component({
  selector: 'app-solicitacoes',
  templateUrl: './solicitacoes.component.html',
  styleUrls: ['./solicitacoes.component.scss'],
  providers: [],
})
export class SolicitacoesComponent implements OnInit {
  // ** inputs ** //
  @Input() public exibeBotaoVerMais: boolean = false;

  // ** variaveis de tela ** //
  public exibeDivSemSolicitacoes: boolean = false;

  public carregandoSolicitacoes: boolean = false;
  public exibirModalRecusarSolicitacao: boolean = false;
  public exibirModalAprovarSolicitacao: boolean = false;
  public exibirModalDesfazerSolicitacao: boolean = false;

  public listSolicitacoes: Solicitacoes[] = [];

  public solicitacoesPendentes: Solicitacoes[] = [];
  public solicitacoesConcluidas: Solicitacoes[] = [];

  public solicitacaoRecusar: Solicitacoes = null;
  public solicitacaoAprovada: Solicitacoes = null;
  public solicitacaoDesfazer: Solicitacoes = null;

  public exibirLoader: boolean = false;
  public tituloModalGenerico: string = '';
  public descricaoModalGenerico: string[] = [];
  public exibePopupGenerico: boolean = false;

  constructor(private fidelidadeService: FidelidadeService) {
    this.obterSolicitacoes();
  }

  ngOnInit(): void {}

  // ** EVENTOS DE TELA **/
  public onClickVerMais() {
    this.filtrarSolicitacoesTela();
  }

  public exibirBotaoCarregarMais() {
    return false;
  }

  // ** METODOS PRIVADOS ** //
  private obterSolicitacoes() {
    this.listSolicitacoes = [];
    this.carregandoSolicitacoes = true;

    const solicitacoesStatus: SolicitacoesStatus[] = [];

    solicitacoesStatus.push(SolicitacoesStatus.EmAnalise);
    solicitacoesStatus.push(SolicitacoesStatus.Aprovado);
    solicitacoesStatus.push(SolicitacoesStatus.Rejeitado);

    const lstTipoAprovacao: number[] = [];

    lstTipoAprovacao.push(1);

    this.fidelidadeService.obterMembro().subscribe((sucesso: Membro) => {
      this.fidelidadeService
        .ObterSolicitacoesPorIdMembroAprovador(
          sucesso.id,
          lstTipoAprovacao,
          solicitacoesStatus
        )
        .subscribe(
          (sucesso) => {
            this.processarSucessoObterSolicitacoesPorIdMembroAprovador(sucesso);
          },
          (falha) => {
            this.processarFalhaObterSolicitacoesPorIdMembroAprovador(falha);
          }
        );
      (falha) => {
        this.processarFalhaObterSolicitacoesPorIdMembroAprovador(falha);
      };
    });
  }

  private processarSucessoObterSolicitacoesPorIdMembroAprovador(response: any) {
    for (let index = 0; index < response.length; index++) {
      const element = response[index];

      this.listSolicitacoes.push(element);
    }

    this.carregandoSolicitacoes = false;

    this.filtrarSolicitacoesTela();
  }

  private processarFalhaObterSolicitacoesPorIdMembroAprovador(response: any) {
    console.error(response);
    this.carregandoSolicitacoes = false;
    this.exibirDivSemSolicitacoes();
  }

  private filtrarSolicitacoesTela() {
    this.limparSolicitacoes();

    if (this.listSolicitacoes.length <= 0) this.exibirDivSemSolicitacoes();

    for (let index = 0; index < this.listSolicitacoes.length; index++) {
      let element = this.listSolicitacoes[index];

      if (element.idStatus == SolicitacoesStatus.EmAnalise) {
        element = { ...element, aceiteTermo: false };
        this.solicitacoesPendentes.push(element);
      }

      if (
        element.idStatus == SolicitacoesStatus.Aprovado ||
        element.idStatus == SolicitacoesStatus.Rejeitado
      )
        this.solicitacoesConcluidas.push(element);
    }

    if(this.solicitacoesPendentes != null && this.solicitacoesPendentes.length > 0)
      this.solicitacoesPendentes = this.solicitacoesPendentes.reverse();

    if(this.solicitacoesConcluidas != null && this.solicitacoesConcluidas.length > 0)
      this.solicitacoesConcluidas = this.solicitacoesConcluidas.reverse();
      
  }

  private limparSolicitacoes() {
    this.solicitacoesPendentes = [];
    this.solicitacoesConcluidas = [];
  }

  private exibirDivSemSolicitacoes() {
    this.exibeDivSemSolicitacoes = true;
  }

  public exibirRecusarSolicitacao(exibir: boolean, solicitacao: Solicitacoes) {
    this.exibirModalRecusarSolicitacao = exibir;
    this.solicitacaoRecusar = solicitacao;
  }

  public exibirAprovarSolicitacao(exibir: boolean, solicitacao: Solicitacoes) {
    this.exibirModalAprovarSolicitacao = exibir;
    this.solicitacaoAprovada = solicitacao;
  }

  public exibirDesfazerSolicitacao(exibir: boolean, solicitacao: Solicitacoes) {
    this.exibirModalDesfazerSolicitacao = exibir;
    this.solicitacaoDesfazer = solicitacao;
  }

  public recusarSolicitacao() {
    if (this.solicitacaoRecusar != null) {
      this.solicitacaoRecusar.idStatus = SolicitacoesStatus.Rejeitado;

      this.exibirLoader = true;

      this.fidelidadeService
        .atualizarSolicitacao(this.solicitacaoRecusar)
        .subscribe(
          (sucesso) => {
            exibirToast('success', 'Solicitação rejeitada com sucesso!');

            this.exibirRecusarSolicitacao(false, null);
            this.limparSolicitacoes();
            this.obterSolicitacoes();

            this.exibirLoader = false;
          },
          (falha) => {
            exibirToast(
              'error',
              'Desculpe, houve um problema na solicitação! Tente novamente mais tarde!'
            );
            this.exibirLoader = false;
          }
        );
    } else
      exibirToast('error', 'Não foi escolhida a solicitação a se recusar!');
  }

  public aprovarSolicitacao() {
    if (this.solicitacaoAprovada != null) {
      this.solicitacaoAprovada.idStatus = SolicitacoesStatus.Aprovado;

      this.exibirLoader = true;

      this.fidelidadeService
        .atualizarSolicitacao(this.solicitacaoAprovada)
        .subscribe(
          (sucesso) => {
            exibirToast('success', 'Solicitação aprovada com sucesso!');

            this.exibirAprovarSolicitacao(false, null);
            this.limparSolicitacoes();
            this.obterSolicitacoes();

            this.exibirLoader = false;
          },
          (falha) => {
            exibirToast(
              'error',
              'Desculpe, houve um problema na solicitação! Tente novamente mais tarde!'
            );
            this.exibirLoader = false;
          }
        );
    } else
      exibirToast('error', 'Não foi escolhida a solicitação a ser aprovada!');
  }

  private desfazerSolicitacao() {
    if (this.solicitacaoDesfazer != null) {
      this.solicitacaoDesfazer.idStatus = SolicitacoesStatus.EmAnalise;
      this.fidelidadeService
        .atualizarSolicitacao(this.solicitacaoDesfazer)
        .subscribe(
          (sucesso) => {
            exibirToast('success', 'Solicitação desfeita com sucesso!');

            this.exibirDesfazerSolicitacao(false, null);

            this.limparSolicitacoes();
            this.obterSolicitacoes();
          },
          (falha) => {
            exibirToast(
              'error',
              'Desculpe, houve um problema na solicitação! Tente novamente mais tarde!'
            );
          }
        );
    } else
      exibirToast('error', 'Não foi escolhida a solicitação a se desfazer!');
  }

  public mostrarPopupTermos() {
    this.descricaoModalGenerico = [];
    this.tituloModalGenerico = '';

    this.exibirLoader = true;
    this.fidelidadeService
      .obterConfiguracaoPorDescricao('TermoResponsabilidade')
      .subscribe(
        (sucesso) => {
          this.processarSucessoTermos(sucesso);
        },
        (falha) => {
          this.processarFalhaTermos(falha);
        }
      );
  }

  private processarSucessoTermos(response: any) {
    let linhas = response.valor.split('\n');

    for (let index = 1; index < linhas.length; index++) {
      if (linhas[index] == '\r') continue;

      this.descricaoModalGenerico.push(`${linhas[index]}<br><br>`);
    }

    this.exibePopupGenerico = true;
    this.tituloModalGenerico = linhas[0];

    this.exibirLoader = false;
  }

  private processarFalhaTermos(fail: any) {
    this.exibirLoader = false;
    console.error('Ocorreu um erro ao obter o termo: ', fail);
  }
}
